<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            
      <div class="risk_" >
        <div class="form_item">
          <label class="item-label">计划名称</label>
              <div class="right_" style="width: 300px">
                <a-select :disabled="disabledAll" placeholder="请选择" class="select_" @change="value => changeData(value, 'planSelect')" v-model="countData.planSelect">
                  <a-select-option v-for="item in planOptions" :key="item.value" :value="item.value">{{ item.name }} </a-select-option>
                </a-select>
              </div>
        </div>
        <div class="form_item">
          <label class="item-label">保障期间</label>
          <div class="right_">
            <a-select :disabled="true" placeholder="请选择保障期间" @change="value => changeData(value, 'BZQJa')" style="width: 300px" class="select_" v-model="countData.BZQJa">
              <a-select-option v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }} </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item">
          <label class="item-label">投保总人数</label>
          <div class="right_" v-for="item in occupationNumberList" :key="item.occupationKind">
            <a-input :disabled="disabledAll" style="width:300px" v-model="item.personNum"  @change="value => changeData(value, 'TBZYa')"></a-input>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" @click="goplicy" v-if="!agreementRead"> 完成报价，立即投保</a-button>
          <a-button class="calBtn_" :disabled="disabledAll" type="primary" @click="countPremiumSum()">刷新试算</a-button>
        </div>
      </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ order">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      rules: {
        planSelect: [{ required: true, message: '请选择计划', trigger: 'change' }]
      },
      productCode: '',
      plan: '',
      //保障期间
      guarantPre: DATA.guarantPre,
      premiumSum: 0, //总保费
      // 保障方案选择
      planOptions: DATA.plansValues,
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: DATA.KZSCOptions,
      YWZYJTOptions: DATA.YWZYJTOptions,
      YWZBOptions: DATA.YWZBOptions,
      // 测算要提交的数据
      countData: {
        BZQJa: '12', //保障期间?
        TBZYa: 0, //投保职业?
        planSelect: 'BABJ1', //保障方案选择
        YWSGSC: 0, //意外身故及伤残保障
        YWYYBT: 0, //意外医药补贴
        YWMRJT: 0, //意外每日住院津贴
        YWJHZYJT: -1, //重症监护病房住院津贴以及猝死
        YWJBZZJHJT: 0, //意外/疾病重症监护病房住院津贴
        CS: 0, //猝死
        YWSGSZ: -1, //意外身故丧葬费用
        YWSGSZXE: 0, //意外身故丧葬费用限额
        JTGJYWSC: -1, //交通工具意外身故/伤残
        GLGGJT: 0, //公共汽车意外身故及伤残保障
        JCSJGS: 0 //私家车和公司班车意外身故及伤残保障
      },
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: '', //产品code
          bracket: '1', //保费期限
          planCode: ''
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      },
      planType: 'A',
      occupationNumberList: [
        {
          occupationName: '1',
          occupationKind: '',
          personNum: 0
        }
      ]
    };
  },
  filters: {
    million: value => {
      let num;
      if (value > 9999) {
        num = Math.floor(value / 1000) / 10 + '万';
      } else if (value < 9999 && value > -9999) {
        num = value;
      } else if (value < -9999) {
        //小于-9999显示-x.xx万
        num = -(Math.floor(Math.abs(value) / 1000) / 10) + '万';
      }
      return num;
    }
  },
  computed: {
      // 选的总投保人数
    totalNumber() {
      let num1_4 = 0,
        num5_6 = 0;
      this.occupationNumberList.slice(0, 4).forEach(e => {
        num1_4 += Number(e.personNum);
      });
      this.occupationNumberList.slice(4).forEach(e => {
        num5_6 += Number(e.personNum);
      });

      return {
        allNumber: parseInt(num1_4 + num5_6),
        num1_4,
        num5_6
      };
    }
  },
  watch: {},
  props: ['disabledAll'],
  created() {
    this.countPremiumSum('init');
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      let obj = this.$lodash.cloneDeep(data);
      // 回显传值的问题
      this.countData.planSelect = obj.salPolicy.planCode;
      this.countData.BZQJa = obj.salPolicy.bracket;
      this.changeData();
    });
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    // 改变试算的数据
    changeData(value, param) {
      this.countData[param] = value;
      this.data = {
        riskInfos: [], //险种信息
        salPolicy: {
          productCode: this.$route.query.p, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          planCode: this.countData.planSelect
        },
        salPolicyExt: {
          isworkheightinvolved: 2,
          occEmpVersion: this.fileCodeContent.id
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: this.occupationNumberList //人数
      };
      this.$bus.$emit('onRiskInfos', this.data);
    },
    //保费试算
    countPremiumSum(type) {
      this.data.salPolicyHolder.addfifty = '1';
      if (type != 'init') {
        if (!this.totalNumber.allNumber) {
          this.$message.warning('请先选择投保人');
          return;
        }
      }
      if (type == 'init') {
        this.data.salPolicy.productCode = this.productCode;
        this.data.salPolicy.planCode = this.plan;
        this.data.salPolicy.creator = '1';
        this.data.salPolicy.bracket = '1';
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.calPremiumEmployer(this.data).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              // this.countTotalPremium(data); // 计算每个人的总保费
              this.premiumSum = data.totalPremium;
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    },
    // 根据人数计算保费
    countTotalPremium(data) {
      let totalPremium = 0;
      this.occupationNumberList.forEach(element => {
        let pNum = parseInt(element.personNum) || 0;
        let premium = data[element.occupationKind] * 10000;
        let occupationPremium = (pNum * premium) / 10000;
        totalPremium += occupationPremium;
      });
      this.premiumSum = totalPremium;
    }
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
  }
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
    margin-top:20px;
  }

.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.waring-color {
  font-size: 12px;
  color: #e6a23c;
}

.gsdiposition {
  width: 300px;
}

.gsdc-icon {
  margin: 3px 3px 0;
}

.zuxianclass {
  margin-bottom: 6px;
  width: 690px;
  display: flex;
  margin-top: 6px;
}

.item-label {
  margin-top: 5px !important;
}
</style>
